import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaRegEdit, FaSearch, FaFilter, FaEraser } from "react-icons/fa";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import api from "../../services/api";
import { hasPerm } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import { formataDataExibicao, formataDataHoraExibicao, formatarValorLocal, getCurrentUser, formataCNPJ } from '../../common/utils';

class Faturamentos extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.carregaProgramasDelay = this.delayCamposAsync(this.carregaProgramas.bind(this), 3000);
        this.carregaPrestadoresDelay = this.delayCamposAsync(this.carregaPrestadores.bind(this), 3000);

        this.state = {
            listRegistros: [],
            error: "", 
            busca: "",
            page_numb: 1,
            loading: true,
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_prestador_id: '',
            filtro_prestador_nome: '',
            filtro_categoria_prestador_id: '',
            filtro_categoria_prestador_nome: '',
            filtro_pago: '',
            filtro_status_nf: '',
            prestador_select_key: 0,
            filtro_cancelado: '',
            filtro_numero_nf: '',
            filtro_id_faturamento: '',
            tipo_usuario: '',
            ambiente_programa_id: '',
            filtro_categoria_prestador: '',
            programasOptions: [],
            loadingProgramas: false,
            prestadoresOptions: [],
            loadingPrestadores: false,
        };

        this.categoriasPrestador = {
            "medicos": "Médicos",
            "multiprofissionais": "Multiprofissionais", 
            "farmacias": "Farmácias",
            "hospitais": "Hospitais",
            "clinicas": "Clinicas",
            "plataformas": "Plataformas",
            "servicos_diagnostico": "Serviços Diagnóstico",
            "laboratorio_diagnostico": "Laboratório Diagnóstico",
            "cooperativas_saude": "Cooperativas de Saúde",
            "motoristas": "Transporte",
            "logistica": "Logística",
            "outros": "Outros"
        };
    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        let ambiente_programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : '';
        this.setState({
            ambiente_programa_id: ambiente_programa_id
        }, () => {
            this.carregaProgramas("")
            this.carregaPrestadores("")
            this.consultaRegistros()
        })
    }

    consultaRegistros(){
        let dados_usuario = getCurrentUser();
        const programa_id = this.state.ambiente_programa_id ? this.state.ambiente_programa_id : this.state.filtro_programa_id;

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario
        })

        let filtros = `?page=${this.state.page_numb}&tipo_usuario=${dados_usuario.tipo_usuario}`

        if(this.state.filtro_data_inicio){
            filtros += '&data_inicio='+this.state.filtro_data_inicio
        }

        if(this.state.filtro_data_fim){
            filtros += '&data_fim='+this.state.filtro_data_fim
        }

        if(programa_id){
            filtros += `&programa_id=${programa_id}`
        }

        if(this.state.filtro_prestador_id){
            filtros += `&laboratorio_id=${this.state.filtro_prestador_id}`
        }

        if(this.state.filtro_pago){
            filtros += '&pago='+this.state.filtro_pago
        }

        if(this.state.filtro_status_nf){
            filtros += '&nota_fiscal_status='+this.state.filtro_status_nf
        }

        if(this.state.filtro_categoria_prestador){
            filtros += '&categoria='+this.state.filtro_categoria_prestador
        }

        if(this.state.filtro_cancelado){
            filtros += '&cancelado='+this.state.filtro_cancelado
        }

        if(this.state.filtro_numero_nf){
            filtros += '&nota_fiscal_numero='+this.state.filtro_numero_nf
        }

        if(this.state.filtro_id_faturamento){
            filtros += '&id='+this.state.filtro_id_faturamento
        }

        api.get(`/faturamento/${filtros}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar faturamentos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label,  
                filtro_prestador_id: '',
                filtro_prestador_nome: ''
            }, () => {
                //this.carregaPrestadores("", true)
            });
        }
        else if(fieldName == 'prestador_id') {
            this.setState({ 
                filtro_prestador_id: event.value, 
                filtro_prestador_nome: event.label, 
            });
        } else if(fieldName == 'filtro_categoria_prestador') {
            const { value } = event.target;
            const label = event.target.options[event.target.selectedIndex].text;
            this.setState(prevState => ({
                filtro_categoria_prestador: value,
                filtro_categoria_prestador_id: value,
                filtro_categoria_prestador_nome: label,
                filtro_prestador_id: "", 
                filtro_prestador_nome: "", 
                prestador_select_key: prevState.prestador_select_key + 1 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    delayCamposAsync = (fn, delay = 3000) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            return new Promise((resolve) => {
            timeout = setTimeout(async () => {
                try {
                const res = await fn(...args);
                resolve(res);
                } catch (e) {
                resolve([]); 
                }
            }, delay);
            });
        };
    };

    handleChangeFiltrosPagamento = (event) => {
        const { name, value } = event.target;
        console.log(`Campo alterado: ${name}, Valor: ${value}`);
    
        this.setState({ [name]: value }, () => {
            console.log("Estado atualizado:", this.state);
            this.consultaRegistros(); 
        });
    };

    carregaProgramas = async (inputValue = "") => {
        try {
            if (!inputValue) {
                this.setState({ loadingProgramas: true });
            }
            let response;

            if (this.state.ambiente_programa_id) {
                response = await api.get(`/programas/?programa_id=${this.state.ambiente_programa_id}`);
            } else {
                response = await api.get(`/programas/?nome=${inputValue}`);
            }

            const opcoes = response.data.results.map(programa => {
                if (programa.id === parseInt(this.state.ambiente_programa_id)) {
                    this.setState({
                        filtro_programa_id: programa.id,
                        filtro_programa_nome: programa.nome
                    });
                }
                return {
                    value: programa.id,
                    label: programa.nome
                };
            });

            if (!inputValue) {
                this.setState({
                    programasOptions: opcoes,
                    loadingProgramas: false
                });
            }
            return opcoes;

        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            if (!inputValue) {
                this.setState({ loadingProgramas: false });
            }
            return [];
        }
    };

    carregaPrestadores = async (inputValue = "") => {
        const programa_id = this.state.ambiente_programa_id ? this.state.ambiente_programa_id : this.state.filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            if (!inputValue) {
                this.setState({ loadingPrestadores: true });
            }

            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&programa_id=${programa_id}&categoria=${this.state.filtro_categoria_prestador_id}`);

            const opcoes = response.data.results.map(prestador => {
                const localizacao = [prestador.bairro, prestador.cidade]
                    .filter(Boolean)
                    .join(", ");

                return {
                    value: prestador.id,
                    label: `${prestador.nome} (${prestador.cpf_cnpj}${localizacao ? " - " + localizacao : ""})`
                };
            });

            if (!inputValue) {
                this.setState({
                    prestadoresOptions: opcoes,
                    loadingPrestadores: false
                });
            }
            return opcoes;

        } catch (error) {
            console.error("Erro ao carregar prestadores:", error);
            if (!inputValue) {
                this.setState({ loadingPrestadores: false });
            }
            return [];
        }
    };


    getLabelNotaFiscal = (nota, nota_fiscal_status) => {
        let style_options = {
            backgroundColor: '#3cc172',
            color: '#ffffff',
            padding: '5px 10px',
            fontSize: '12px',
            borderRadius: '5px',
            display: 'inline-block',
        }
        let texto = 'Aprovado'

        if(!nota){
            texto = 'Pendente'
            style_options['backgroundColor'] = 'orange'
            style_options['color'] = '#fff'
        }
        else if(nota_fiscal_status == 'analise'){
            texto = 'Em analise'
            style_options['backgroundColor'] = '#f2f2f2'
            style_options['color'] = '#252f4a'
        }
        else if(nota_fiscal_status == 'recusado'){
            texto = 'Recusado'
            style_options['backgroundColor'] = '#eb4961'
            style_options['color'] = '#fff'
        } else if(nota_fiscal_status == 'cancelado'){
            texto = 'Cancelado'
            style_options['backgroundColor'] = '#eb4961'
            style_options['color'] = '#fff'
        }

        return <span style={style_options}>
            {texto}
        </span>
    }

    cancelarFaturamento = (id, lista_atendimentos, tipo_faturamento) => {
        const MySwal = withReactContent(Swal);
        let string_atendimentos = lista_atendimentos.map(atendimento => atendimento.id).join(',');
        MySwal.fire({
            title: 'Deseja realmente cancelar este faturamento?',
            text: "Esta ação não poderá ser revertida!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6', 
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, cancelar!',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                // Envia para API
                const updateFaturamento = {
                    cancelado: true,
                    atendimentos_cadastro: string_atendimentos,
                    tipo_faturamento: tipo_faturamento
                }

                api({
                    method: 'put',
                    url: '/faturamento/' + id + '/',
                    data: updateFaturamento,
                })
                .then(response => {
                    const MySwal = withReactContent(Swal);
            
                    this.setState({
                        loading: false,
                    });
            
                    MySwal.fire({
                        title: <p>Faturamento cancelado com sucesso</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then((result) => {
                        window.location.reload();
                    });             
                })
                .catch(error => {
                    let erro_msg = 'Erro ao cancelar o faturamento, verifique os campos e tente novamente';            
            
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }
            
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    });
            
                    this.setState({
                        loading: false,
                    });
                });
            }
        });
    }

    renderRows = () => {   
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id} title={item.cancelado ? 'Faturamento cancelado' : ''}>
                <td>{item.id}</td>
                <td>{item.data_inicio ? formataDataExibicao(item.data_inicio) : '---'} à {item.data_fim ? formataDataExibicao(item.data_fim) : '---'}</td>
                <td>
                    {item.pago ? 'Sim' : 'Não'}
                    {item.data_pagamento &&
                    <>
                        <br />
                        <small>Pago em: {formataDataHoraExibicao(item.data_pagamento)}</small>
                    </>
                    }
                </td>
                <td>{(item.data_vencimento) ? formataDataExibicao(item.data_vencimento) : '--'}</td>
                <td>
                    {item.dados_laboratorio.nome}
                    <br />
                    <small>CNPJ: {formataCNPJ(item.dados_laboratorio.cpf_cnpj)}</small>
                </td>
                <td>{item.dados_programa.nome}</td>
                <td>{item.valor_total ? formatarValorLocal(item.valor_total) : 'R$ 0,00'}</td>
                <td>
                    {item.cancelado ? this.getLabelNotaFiscal('cancelado', 'cancelado') : this.getLabelNotaFiscal(item.nota, item.nota_fiscal_status)}   
                </td>
                {this.state.tipo_usuario !== 'prestador' && (
                    <>
                    <td>{item.nota_comissao_numero ? item.nota_comissao_numero : '--'}</td>
                    <td>
                    {item.taxa_administrativa_valor && (
                        <>
                            {item.taxa_administrativa_valor 
                            ? parseFloat(item.taxa_administrativa_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                            : ''}
                        &nbsp;({item.taxa_administrativa 
                            ? parseFloat(item.taxa_administrativa).toLocaleString('pt-BR')
                            : ''}%)
                        </>
                    )}
                    </td>
                    </>
                )}
                
                <td>
                    
                        <Button variant="light" href={"/faturamentos/edit/"+item.id} size="sm">
                            <FaRegEdit /> Visualizar
                        </Button>   
                    
                    {!item.cancelado && !item.pago && this.state.tipo_usuario !== 'prestador' && item.dados_programa.tipo_faturamento === 'servico' && (
                        <Button variant="danger" onClick={() => this.cancelarFaturamento(item.id, item.lista_atendimentos, item.dados_programa.tipo_faturamento)} size="sm">
                            Cancelar
                        </Button>    
                    )} 
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={7}>Nenhum faturamento encontrado</td>
            </tr>
        );
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.consultaRegistros();
        });
    };

    filtrarFaturamento = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.consultaRegistros()
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_programa_id: null,
            filtro_programa_nome: '',
            filtro_prestador_id: null,
            filtro_prestador_nome: '',
            filtro_pago: '',
            filtro_status_nf: '',
            filtro_numero_nf: '',
            page_numb: 1, // Reseta a paginação, se necessário
        }, () => {
            this.consultaRegistros(); // Chama a função para consultar registros com os filtros limpos
        });
    };

    render() {        
        if (!hasPerm('view_faturamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Faturamentos</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.filtrarFaturamento}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control type="date" name="filtro_data_inicio" value={this.state.filtro_data_inicio} onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Final</Form.Label>
                                        <Form.Control type="date" name="filtro_data_fim" value={this.state.filtro_data_fim} onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')} />    
                                    </Form.Group>
                                </Col>
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={6} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programas</Form.Label>
                                        <AsyncSelect           
                                            key={this.state.programa_id}                     
                                            cacheOptions
                                            loadOptions={this.carregaProgramasDelay} 
                                            defaultOptions                       
                                            onMenuOpen={() => this.carregaProgramas("")} 
                                            name="programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            isDisabled={this.state.ambiente_programa_id ? true : false}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Categoria (Prestador)</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="filtro_categoria_prestador" 
                                            value={this.state.filtro_categoria_prestador} 
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_categoria_prestador')}
                                        >
                                            <option value="">Todos</option>
                                        {Object.entries(this.categoriasPrestador).map(([key, value]) => (
                                            <option key={key} value={key}>{value}</option>
                                        ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={8} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prestador</Form.Label>
                                        <AsyncSelect            
                                           key={this.state.filtro_programa_id}                     
                                            cacheOptions
                                            loadOptions={this.carregaPrestadoresDelay} 
                                            defaultOptions
                                            onMenuOpen={() => this.carregaPrestadores("")}
                                            name="prestador_id"
                                            placeholder='Buscar prestador...'
                                            noOptionsMessage={() => "Nenhum resultado encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'prestador_id')}
                                            value={this.state.filtro_prestador_id ? { value: this.state.filtro_prestador_id, label: this.state.filtro_prestador_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                </>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Pago</Form.Label>
                                        <Form.Control 
                                        as="select" 
                                        name="filtro_pago" 
                                        value={this.state.filtro_pago} 
                                        onChange={this.handleChangeFiltrosPagamento}
                                        >
                                        <option value="">Situação do Pagamento...</option>
                                        <option value="true">Sim</option>
                                        <option value="false">Não</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status NF</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="filtro_status_nf" 
                                            value={this.state.filtro_status_nf} 
                                            onChange={this.handleChangeFiltrosPagamento}
                                        >
                                            <option value="">Situação da Nota Fiscal...</option>
                                            <option value="analise"> Em Análise / Pendente</option>
                                            <option value="aprovado">Aprovado</option>
                                            <option value="recusado">Recusado</option>
                                        </Form.Control>
                                        </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={2} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>ID Faturamento</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="filtro_id_faturamento" 
                                            value={this.state.filtro_id_faturamento} 
                                            onChange={this.handleChangeFiltrosPagamento}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={2} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cancelado</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="filtro_cancelado" 
                                            value={this.state.filtro_cancelado} 
                                            onChange={this.handleChangeFiltrosPagamento}
                                        >
                                            <option value="">Todos</option>
                                            <option value="true">Sim</option>
                                            <option value="false">Não</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={2} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nº da Nota Fiscal</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            name="filtro_numero_nf" 
                                            value={this.state.filtro_numero_nf} 
                                            onChange={this.handleChangeFiltros}
                                            placeholder="Digite o número da NF"
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            
                            </Row>      
                            <Button type="submit" variant="secondary" size="sm">
                                <FaSearch /> Filtrar
                            </Button>
                            <Button type="button" variant="secondary" size="sm" onClick={() => this.limpaFiltro()}>
                                <FaEraser /> Limpar Filtro
                            </Button>
                        </Form> 

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>OS</th>
                                    <th>Período</th>
                                    <th>Pagamento</th>
                                    <th>Vencimento</th>
                                    <th>Prestador</th>
                                    <th>Programa</th>
                                    <th>Valor total</th>
                                    <th>Nota fiscal</th>
                                    {this.state.tipo_usuario !== 'prestador' && (
                                        <>
                                            <th>Nota de Comissão</th>
                                            <th>Taxa Adm.</th>
                                        </>
                                    )}
                                    <th>Opções</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>

                
            </div>
        );
    }
}

export default withRouter(Faturamentos);